import styled from "../../styled-components";

export const StyledErrorMessage = styled.p`
  color: ${props => props.theme.colors.red[500]};
`;
